import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { from, switchMap, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api.service';
import { BirthdayFilters, BirthdayResponse } from 'src/app/models/core/birthdays.model';
import { ConsumedProductsResponse } from 'src/app/models/core/consumed-product';


@Injectable({
  providedIn: 'root'
})
export class BirthdayApiService {

  private baseUrl = `${environment.api_server}/api`;

  constructor(private _http: HttpClient, private _api: ApiService) { }

  getBirthdays(filters?: BirthdayFilters): Observable<BirthdayResponse> {
    const url = `${this.baseUrl}/v2/seller-assistants-birthdays`;

    let params = new HttpParams();

    if (filters?.range) {
      params = params.set('range', filters.range);
    }

    if (filters?.per_page) {
      params = params.set('per_page', filters.per_page.toString());
    }

    if (filters?.page) {
      params = params.set('page', filters.page.toString());
    }

    return from(this._api.getAuthHeaders()).pipe(
      switchMap((headers) =>
        this._http.get<BirthdayResponse>(url, {
          headers,
          params
        })
      )
    );
  }

  getHistoricalConsumedProductsByAssistant(
    assistantId: number | string,
    role: string,
    page = 1,
    perPage = 10
  ): Observable<ConsumedProductsResponse> {
    const url = `${this.baseUrl}/sellers/assistants/${assistantId}/historical-consumed-products`;

    const params = new HttpParams()
      .set('role', role)
      .set('page', page.toString())
      .set('per_page', perPage.toString());

    return from(this._api.getAuthHeaders()).pipe(
      switchMap((headers) =>
        this._http.get<any>(url, { headers, params })
      )
    );
  }

  getHistoricalConsumptionKpis(assistantId: number, role?: string): Observable<any> {
    const url = `${this.baseUrl}/sellers/dashboard/assistant-historical-kpis`;
    
    let httpParams = new HttpParams().set('assistant_id', assistantId.toString());
    
    if (role) {
      httpParams = httpParams.set('role', role);
    }
  
    return from(this._api.getAuthHeaders()).pipe(
      switchMap((headers) =>
        this._http.get(url, { headers, params: httpParams })
      )
    );
  }

}